module.exports = __webpack_public_path__ + "08_hige_white.193eeb90.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/08_hige_white.png
// module id = Ju6s
// module chunks = 0